import React from 'react'
import { Typography } from '@the-platform-group/component-library'
import {
  Modal,
  ModalTitle,
  ModalContent,
  ModalActions,
} from '@the-platform-group/component-library/Modal'
import { Button } from '@the-platform-group/component-library/Button'

const DeleteTearsheetTemplateModal = ({
  open,
  template,
  customerName,
  onClose,
  onDelete,
  isLoading,
}) => {
  if (!template) return null

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle title={`Delete ${template.name}?`} />
      <ModalContent>
        <Typography variant="body1">
          If you delete this template {customerName} will no longer be able to access it. Please
          note that deleting a template will not delete it in Sigma.
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button color="error" isLoading={isLoading} onClick={() => onDelete(template.id)}>
          Delete
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default DeleteTearsheetTemplateModal
